import React, { useState, useEffect, useRef } from "react";
import "./css/employerApplication.css";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropagateLoader from "react-spinners/PropagateLoader";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaCrown } from "react-icons/fa";
import { IoCloseCircleOutline } from "react-icons/io5";
import { FaRegPenToSquare } from "react-icons/fa6";
import { MdContentCopy } from "react-icons/md";
import { CiViewList } from "react-icons/ci";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Dropdown } from "react-bootstrap";
import Alert from "@mui/material/Alert";
import { IoEyeOutline } from "react-icons/io5";
import { Tooltip } from "@material-tailwind/react";
import { Link } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { loadUser } from "../../actions/userActions";
import Popup from "reactjs-popup";
import { RxCross1 } from "react-icons/rx";
import { logEvent } from "../../utils/Analytics";
import urlText from "../urlText";


const limit = 15;
function EmployerApplications() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo(0, 0);
  }, []);


  const handleLinkedInShare = (data) => {
    // Construct the LinkedIn share URL
    const linkedinShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=https://hirekingdom.com/preview/${urlText(data?.profile)}-${urlText(data?.opportunityType)}-at-${urlText(data?.employer?.organisationName)}_${data._id}`;

    // Open LinkedIn share URL in a new tab
    window.open(linkedinShareUrl, '_blank');
  };
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [jobData, setJobData] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [forceRender, setForceRender] = useState(false);
  // const [toggleButton, setToggleButton] = useState(true);
  const [toggleButton, setToggleButton] = useState(location.pathname.includes('Internship'));
  const [showAlert, setShowAlert] = useState(false);
  const [newDate, setNewDate] = useState(false);
  const [selectedJob, setSelectedJob] = useState("");
  // useEffect(() => {
  //   dispatch(loadUser());
  // }, []);
  const getUserData = async (page) => {
    setLoading(true);

    try {
      const { data } = await axios.post(
        "/api/employer/getAllJobs",
        { page, opportunityType: toggleButton ? "Internship" : "Job" },
        {
          headers: {
            "Content-Type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      );
      const jobD = data.jobs;
      setCount(data.count);
      setJobData(jobD);
      setLoading(false);
    } catch (error) {
      console.log(error.response.data);
      setLoading(false);
    }
  };

  const forw = () => {
    setPage((prev) => prev + 1);
    window.scrollTo(0, 0);
  };

  const backw = () => {
    setPage((prev) => prev - 1);
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    getUserData(page);
  }, []);

  useEffect(() => {
    getUserData(1);
  }, [toggleButton]);

  const handleCloseJob = async (jobId) => {
    const status = "Close";
    try {
      const response = await axios.post(
        `/api/employer/closeJob/${jobId}`,
        { status },
        {
          headers: {
            "Content-Type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      );

      if (response.data.success) {
        toast.success("Job closed successfully");
        setForceRender((prev) => !prev);
      } else {
        console.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowAlert(false);
    }
  };

  useEffect(() => {
    getUserData(page);
  }, [page, forceRender]);

  const handleToggleButton = (state) => {
    setToggleButton(state);
    setPage(1);

    const newType = state ? "Internship" : "Job";
    navigate(`/employerApplication/${newType}`);
  };

  function getDate(date) {
    if (!date) date = new Date();
    else {
      date = new Date(date);
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const handleSetNewDeadline = async () => {
    try {
      const response = await axios.post(
        "/api/employer/setNewDeadline",
        { deadline: newDate, id: selectedJob },
        {
          headers: {
            "Content-Type": "application/json",
            token: localStorage.getItem("token"),
          },
        }
      );

      if (response.status == 200) {
        alert("Deadline extended successfully");
      }
    } catch (error) {
      console.log(error);
    } finally {
      getUserData(page);
      setShowAlert(false);
    }
  };

  const handleExtendDeadline = async (value, id) => {
    const date = new Date(value);
    setNewDate(date);
    setSelectedJob(id);
    setShowAlert(true);
    window.scrollTo(0, 0);
  };
  jobData && jobData?.sort((a, b) => new Date(b.datePosted) - new Date(a.datePosted));
  console.log(jobData, "after sort")

  const [showModal, setShowModal] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);

  const handleDeleteConfirmation = (id) => {
    setIdToDelete(id);
    setShowModal(true);
  };

  const handleConfirmDelete = async () => {
    await handleCloseJob(idToDelete);
    setShowModal(false);
  };

  const handleCancelDelete = () => {
    setShowModal(false);
  };

  const handleAddEvent = (str) => {
    logEvent("Button", `Clicked ${str} button`);
  };
  return (
    <>
      <div id="my-applications">
        {showAlert && (
          <div
            className="w-50 mx-auto alert alert-primary alert-dismissible fade show d-flex flex-column"
            role="alert"
            style={{ background: "white" }}
          >
            Are you sure you want to extend the internship deadline? Please note that you can extend the deadline only once and the change is
            irreversible.
            <div className="d-flex align-items-center justify-content-center gap-5 mt-2">
              <button onClick={() => handleSetNewDeadline()} type="button" style={{ border: "none", background: "transparent" }}>
                Ok
              </button>
              <button onClick={() => setShowAlert(false)} type="button" style={{ border: "none", background: "transparent" }}>
                Cancel
              </button>
            </div>
          </div>
        )}
        {loading ? (
          <>
            <div className="my-auto" style={{ textAlign: "center" }}>
              <p style={{ color: "#4B92C8", fontWeight: "500", fontSize: "20px", marginLeft: "43px", marginBottom: "5px" }}>Loading..</p>
              <PropagateLoader
                color={"#4B92C8"}
                loading={true}
                size={15}
                aria-label="Loading Spinner"
                data-testid="loader"
                style={{ marginLeft: "27px" }}
              />
            </div>
          </>
        ) : (
          <>
            <div className="d-flex align-items-center justify-content-center">
              {/* <button
                onClick={() => handleToggleButton(true)}
                className={`toggle-btn px-4 py-2 bg-transparent border-2 border-bottom ${toggleButton ? "border-primary text-primary" : "text-dark"}`}
              >
                Internships
              </button>
              <button
                onClick={() => handleToggleButton(false)}
                className={`toggle-btn px-4 py-2 bg-transparent border-2 border-bottom ${
                  !toggleButton ? "border-primary text-primary" : "text-dark"
                }`}
              >
                Jobs
              </button> */}
              <Link
                to="/employerApplication/Internship"
                onClick={() => { handleToggleButton(true); handleAddEvent("Internships") }}
                className={`toggle-btn px-4 py-2 bg-transparent border-2 border-bottom ${toggleButton ? "border-primary text-primary" : "text-dark"}`}
                style={{ textDecoration: 'none' }}
              >
                Internships
              </Link>
              <Link
                to="/employerApplication/Job"
                onClick={() => { handleToggleButton(false); handleAddEvent("Jobs") }}
                className={`toggle-btn px-4 py-2 bg-transparent border-2 border-bottom ${!toggleButton ? "border-primary text-primary" : "text-dark"
                  }`}
                style={{ textDecoration: 'none' }}
              >
                Jobs
              </Link>
            </div>

            {jobData.length > 0 ? (
              <>
                <div className="table-container">
                  <table>
                    <thead style={{ backgroundColor: "f8f8f8" }}>
                      <tr>
                        <th style={{ borderTopLeftRadius: "20px", paddingLeft: "35px" }}>{toggleButton ? "PROFILE" : "JOB TITLE"}</th>
                        <th className="text-center">STATUS</th>
                        <th>TOTAL VIEWs</th>
                        <th className="text-center ">ACTION</th>
                        <th className="text-center">SHARE</th>
                        {/* <th style={{ border: "none", background: "white" }}></th> */}
                        <th style={{ borderTopRightRadius: "20px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {jobData?.map((data, index) => {
                        const fifteenDaysLater = new Date(data.deadline);
                        fifteenDaysLater.setDate(fifteenDaysLater.getDate() + 15);

                        // Check if current date is after 15 days from datePosted
                        const currentDate = new Date();
                        const disableButton = (currentDate > fifteenDaysLater) && (data.status === "Closed" || data.status === "Not Approved");
                        const encodedData = encodeURIComponent(JSON.stringify(data?._id));
                        return (
                          <>
                            <tr key={index}>
                              <td>
                                {data.profile} <br />{" "}
                                {!toggleButton && (
                                  <span style={{ fontSize: "12px" }}>
                                    (Exp: {data?.minExperience || 1}
                                    {data?.maxExperience ? `- ${data.maxExperience}` : ""} years)
                                  </span>
                                )}
                              </td>
                              <td>
                                {data.status == "Not Approved" ? (
                                  <button className="application-status active" style={{ backgroundColor: "#f8f8f8", color: "#484848" }}>
                                    Closed
                                  </button>
                                ) : (
                                  data.status == "Approved" ? (
                                    <button className="application-status active">Active</button>
                                  ) : (
                                    data.status == "Rejected" ? (
                                      <button className="application-status active" style={{ backgroundColor: "#FFEFEF", color: "#CF1D1D" }}>{data.status}</button>
                                    ) : (
                                      <button className="application-status active" style={{ backgroundColor: "#FFFAE3", color: "#D8AF09" }}>{data.status}</button>
                                    )
                                  )
                                )}
                              </td>
                              <td>{data?.totalviews}</td>
                              
                              <td className="view">
                                {disableButton ? (
                                  <button
                                    className={`px-md-4 px-2 py-2 h4 text-white border-0 inactive`}
                                    style={{ minWidth: "80px", width: "100%", cursor: 'not-allowed' }}
                                    disabled
                                  >
                                    View applications ({data?.userApplied?.length})
                                  </button>
                                ) : (
                                  <>
                                    
                                    <a
                                      href={`/employerappreceived/All?data=${encodedData}`}
                                      className={`px-5 py-2 h4 text-white border-0 ${data.status === "Approved" ? "active" : "inactive"}`}
                                      style={{ minWidth: "80px", width: "100%", display: "inline-block", textAlign: "center", textDecoration: 'none' }}
                                    >
                                      View applications ({data?.userApplied?.length})
                                    </a>
                                  </>
                                )}
                              </td>
                              <td style={{ width: "100px" }}>
                                
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg"
                                  onClick={() => handleLinkedInShare(data)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <path
                                    d="M26.0002 25.5V18.9075C26.0002 15.6675 25.3027 13.1925 21.5227 13.1925C19.7002 13.1925 18.4852 14.1825 17.9902 15.1275H17.9452V13.485H14.3677V25.5H18.1027V19.5375C18.1027 17.9625 18.3952 16.455 20.3302 16.455C22.2427 16.455 22.2652 18.2325 22.2652 19.6275V25.4775H26.0002V25.5Z"
                                    fill="#2867B2"
                                  />
                                  <path d="M8.29248 13.485H12.0275V25.5H8.29248V13.485Z" fill="#2867B2" />
                                  <path
                                    d="M10.16 7.5C8.9675 7.5 8 8.4675 8 9.66C8 10.8525 8.9675 11.8425 10.16 11.8425C11.3525 11.8425 12.32 10.8525 12.32 9.66C12.32 8.4675 11.3525 7.5 10.16 7.5Z"
                                    fill="#2867B2"
                                  />
                                  <rect x="1" y="1" width="32" height="32" rx="6" stroke="#2867B2" />
                                </svg>
                                {/*</div>*/}
                              </td>
                              <td>
                                <DropdownHere
                                  data={data}
                                  index={index}
                                  navigate={navigate}
                                  toggleButton={toggleButton}
                                  handleExtendDeadline={handleExtendDeadline}
                                  getDate={getDate}
                                  handleCloseJob={handleCloseJob}
                                />
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

              
                <div className="pagination">
                  <div className="d-flex justify-content-start align-items-center flex-wrap">
                    <a
                      style={{ cursor: "pointer", fontSize: "20px", color: page != 1 ? "#008bdc" : "#484848" }}
                      onClick={() => {
                        page > 1 && backw();
                      }}
                    >{`<`}</a>
                    <span style={{ color: "#484848", fontSize: "14px" }}>
                      {page} / {Math.ceil(count / limit)}
                    </span>
                    <a
                      style={{ cursor: "pointer", fontSize: "20px", color: page < Math.ceil(count / limit) ? "#008bdc" : "#484848" }}
                      onClick={() => {
                        page < Math.ceil(count / limit) && forw();
                      }}
                    >{`>`}</a>
                  </div>
                </div>
              </>
            ) : (
              <div style={{ fontSize: "14px", color: "#e5330e", textAlign: "center" }}>No applications posted</div>
            )}
          </>
        )}
      </div>

      <Popup open={showModal} modal closeOnDocumentClick={false}>
        <div className="overlay" style={{ background: "rgba(0, 0, 0, 0.4)" }}>
          <div className="popup-containernew">
            <div className="success-message mx-3" style={{ marginBottom: '10px' }}>
              Are you sure you want to close?
            </div>
            <div style={{ display: 'flex', alignItems: 'center', alignSelf: 'center', gap: '10px', marginBottom: '15px' }}>
              <button className='employerbuttonbacktodash' onClick={handleCancelDelete}>No</button>
              <button className="employerbuttontobuyinformation" style={{ backgroundColor: '#ED5E68' }} onClick={handleConfirmDelete}>Yes</button>
            </div>

          </div>
        </div>
      </Popup>
    </>
  );
}

const DropdownHere = ({ data, index, navigate, toggleButton, handleExtendDeadline, getDate, handleCloseJob }) => {
  const [extend, setExtend] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const dropdownRef = useRef();
  const handleAddEvent = (str) => {
    logEvent("Button", `Clicked ${str} button`);
  };
  const handleClickOutside = (event) => {
    const dropdownContainer = document.getElementById("dropdown-container");
    if (dropdownRef.current && !dropdownRef.current.contains(event.target) && dropdownContainer && !dropdownContainer.contains(event.target)) {
      setDropdown(false);
      setExtend(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClick = (value, event) => {
    handleExtendDeadline(value, data?._id);
  };
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const confirmCloseJob = () => {
    handleCloseJob(data._id);
    closeModal();
  };

  const openPreviewPageInNewTab = (data) => {
    // const data = state.data;
    // Create sanitized versions of each component
   


   const sanitizedProfile = urlText(data?.profile);
    const sanitizedOpportunityType = urlText(data?.opportunityType);
    const sanitizedOrgName = urlText(data?.organisationName);



    // Construct URL with sanitized components
    const url = `/preview/${sanitizedProfile}-${sanitizedOpportunityType}-at-${sanitizedOrgName}_${data._id}`;
    return url;
};
  return (
    <>
      <div ref={dropdownRef} class="ms-auto" style={{ position: "relative" }}>
        <i
          class="fas fa-ellipsis-vertical"
          onClick={() => {
            setDropdown(!dropdown);
            setExtend(false);
          }}
          style={{ cursor: "pointer" }}
        >
          <BsThreeDotsVertical size={20} />
        </i>

        {dropdown && (
          <div id="dropdown-container">
            <span className="main-span">
              <a onClick={() => handleAddEvent(toggleButton ? "view Internship" : "view Jobs")} href={openPreviewPageInNewTab(data)}>
                <CiViewList />
                <span>View {toggleButton ? "Internship" : "Job"}</span>
              </a>
            </span>
            {data.status == "Approved" && (
              <>
                {/* <span className="main-span" onClick={() => handleCloseJob(data._id)}> */}
                <span className="main-span" onClick={() => { openModal(); handleAddEvent(toggleButton ? "close Internship" : "close Jobs") }}>
                  <IoCloseCircleOutline />
                  <span>Close {toggleButton ? "Internship" : "Job"}</span>
                </span>
              </>
            )}
            {data.status == "Approved" && !data?.deadlineExtended && (
              <span className="main-span">
                <FaRegPenToSquare />
                <span onClick={() => { setExtend(true); handleAddEvent("Extend deadline") }} className="d-flex flex-column align-items-start">
                  <span>Extend deadline</span>
                  <span style={{ fontSize: "13px", color: "#8a8a8a", marginTop: "-4px" }}>(Expires on {getDate(data?.deadline)})</span>
                </span>
              </span>
            )}
            <span className="main-span">
              <a href={`/newpost/${data._id}`} target="_blank" onClick={() => handleAddEvent(toggleButton ? "Post similar Internship" : "Post similar Jobs")}>
                <MdContentCopy />
                <span>Post Similar {toggleButton ? "Internship" : "Job"}</span>
              </a>
            </span>
          </div>
        )}

        {extend && (
          <div id="calendar-container" style={{ position: "absolute", right: "0px", top: "30px", width: "250px", zIndex: "100" }}>
            <Calendar
              minDate={data?.deadline ? new Date(data?.deadline) : new Date()}
              defaultActiveStartDate={data?.deadline ? new Date(data?.deadline) : new Date()}
              onChange={handleClick}
            />
          </div>
        )}
      </div>

      <Popup open={isOpen} closeOnDocumentClick onClose={closeModal}>
        <div className="overlay" style={{ background: "rgba(0, 0, 0, 0.4)" }}>
          <div className="popup-containernew">
            <div className="success-message mx-3" style={{ marginBottom: '10px' }}>
              Are you sure you want to close this {toggleButton ? "Internship" : "Job"}?
            </div>
            <div style={{ display: 'flex', alignItems: 'center', alignSelf: 'center', gap: '10px', marginBottom: '15px' }}>
              <button className="employerbuttonbacktodash" onClick={closeModal}>No</button>
              <button className='employerbuttontobuyinformation' style={{ backgroundColor: '#ED5E68' }} onClick={confirmCloseJob}>Yes</button>
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
};

const TooltipComponent = ({ data, index, getDate, handleExtendDeadline }) => {
  const [open, setOpen] = useState(false);

  const closeRef = useRef();

  const handleClickOutside = (event) => {
    if (closeRef.current && !closeRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClick = (value, event) => {
    handleExtendDeadline(value, data?._id);
  };

  return (
    <>
      {!data?.deadlineExtended && data?.status == "Approved" && (
        <div ref={closeRef}>
          <Tooltip
            key={index}
            placement="bottom"
            open={open}
            content={
              <Calendar
                minDate={data?.deadline ? new Date(data?.deadline) : new Date()}
                defaultActiveStartDate={data?.deadline ? new Date(data?.deadline) : new Date()}
                onChange={handleClick}
              />
            }
          >
            <div style={{ fontSize: "12px", color: "#e5330e", fontWeight: "400" }}>
              Last date to recieve application is {getDate(data?.deadline)}.{" "}
              <span onClick={() => setOpen(!open)} style={{ color: "#008bdc", cursor: "pointer" }}>
                Extend deadline
              </span>
            </div>
          </Tooltip>
        </div>
      )}
      <ToastContainer
        position="top-center"
        autoClose={10000}
      />
    </>
  );
};
export default EmployerApplications;
